import {useFactoryFetch} from "@/composables/useFactoryFetch";
import {ICreateStudentRequest, IGetResult, IUpdateStudentRequest, IUser, QueryFilter} from "@/types/api";
import {API_URLS} from "@/utils/constants/api-urls";
import {AfterFetchContext, MaybeRefOrGetter} from "@vueuse/core";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {computed, toValue} from "vue";

export class UserService {

  static getInstance(): UserService {
    return new UserService();
  }

  async updateUser(user: IUser) {
    const {execute,data} = useAxios<IGetResult>(API_URLS.users.updateById(user._id), {
      method: "PATCH",
      data: user
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }
  async createStudent(body: ICreateStudentRequest) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.users.createStudent, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }
}